// eslint-disable-next-line import/prefer-default-export
export const SET_VEHICLES_CATEGORY_LIST = 'SET_VEHICLES_CATEGORY_LIST';
export const SET_VEHICLES_CATEGORY_INFO = 'SET_VEHICLES_CATEGORY_INFO';
